import { Code } from "react-feather";
import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";
import { PageResult } from "./Pagination";

export interface ILicensingActionRow {
  licenceactionid: string;
  licenceid: string;
  licenceprofileid: string;
  licenceapplicationid: string;
  code: string;
  createdon: string;
  type: string;
  status: string;
  name: string;
  description: string;
  issueddate: string;
  duedate: string;
  repliedondate: string;
}

export interface ILicenceActionDetails extends IDetailsResponse {
  licenceactionid: string;
  licenceid: string;
  licenceprofileid: string;
  licenceapplicationid: string;
  code: string;
  createdon: string;
  type: string;
  status: string;
  name: string;
  description: string;
  issueddate: string;
  duedate: string;
  repliedondate: string;
  licence_regno: string;
}

export function FormatLicenceActionList(rows: Array<any>) {
  return rows.map((item) => {
    return <ILicensingActionRow>{
      licenceactionid: item.complianceinvestigationid,
      licenceid: item.licenceid,
      licenceprofileid: item.issue,
      licenceapplicationid: item.reference,
      code: item.code,
      createdon: formatDate(item.createdon),
      type: item.title,
      status: item.svid,
      name: item.name,
      description: item.description,
      issueddate: formatDate(item.issueddate),
      duedate: formatDate(item.duedate),
      repliedondate: formatDate(item.repliedondate),
    };
  });
}

export interface ILicensingActionList extends PageResult {
  list: ILicensingActionRow[];
}

export const GetLicensingActionsByLicenceFetchUrl = (
  licence_id: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/LicenceAction/filteredlistbylic?licence_id=${licence_id}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-actions-list`;
  }

  return url;
};

export interface ILicensingActionGridFilterValue {
  name: string;
  value: string;
}

export interface ILicensingActionGridFilterValueList {
  count: number;
  list: ILicensingActionGridFilterValue[];
}

export async function GetLicensingActionTypesAsync(): Promise<ILicensingActionGridFilterValueList> {
  let url = `${API_URL}/LicenceAction/lactypefilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licensing-action-types`;
  }

  var response = await fetch(url);
  var body = <ILicensingActionGridFilterValueList>await response.json();
  body.list = body.list.map((item) => {
    return <ILicensingActionGridFilterValue>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetLicensingActionStatusesAsync(): Promise<ILicensingActionGridFilterValueList> {
  let url = `${API_URL}/LicenceAction/lacstatusfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licensing-action-statuses`;
  }

  var response = await fetch(url);
  var body = <ILicensingActionGridFilterValueList>await response.json();
  body.list = body.list.map((item) => {
    return <ILicensingActionGridFilterValue>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetLicenceActionDetailsAsync(
  licenceActionId: string
): Promise<ILicenceActionDetails> {
  var url = `${API_URL}/LicenceAction/byid?licence_action_id=${licenceActionId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-action-details`;
  }

  var response = await fetch(url);
  var body = <ILicenceActionDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <ILicenceActionDetails>{
    response: response,
    licenceactionid: body.licenceactionid,
    licenceid: body.licenceid,
    licenceprofileid: body.licenceprofileid,
    licenceapplicationid: body.licenceapplicationid,
    code: body.code,
    createdon: formatDate(body.createdon),
    type: body.type,
    status: body.status,
    name: body.name,
    description: body.description,
    issueddate: formatDate(body.issueddate),
    duedate: formatDate(body.duedate),
    repliedondate: formatDate(body.repliedondate),
    licence_regno: licenceDetails.reg_no,
  };
}
